import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-end-user-license-agreement',
  templateUrl: './end-user-license-agreement.page.html',
  styleUrls: ['./end-user-license-agreement.page.scss']
})
export class EndUserLicenseAgreementPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
